import verge from './vendor/verge';
import debounce from './vendor/just-debounce';

class LazzyLoaderPic {

  constructor(type, el, src, unloadedClass, immediately) {
    this.type = type || 'image';
    this.garbage = false;
    this.el_img = el;
    this.unloadedClass = unloadedClass;
    this.src = src;
    this._applySrc = () => this.applySrc(this.el_img, src, unloadedClass);
    this.el_loader = null;

    if (immediately) {
      this.preloadImage();
    }
    else {
      this.update();
    }
  }
  inViewport() {
    return this.el_img && this.el_img.offsetParent !== null &&
      verge.inViewport(this.el_img, 100);
  }
  update() {
    if (!this.garbag) {
      if (this.inViewport()) {
        this.preloadImage();
      }
    }
  }

  applySrc() {
    if (this.el_img) {
      if(this.type === 'image') {
        this.el_img.src = this.src;
      } else {
        this.el_img.style.backgroundImage = `url(${this.src})`;
      }
      this.el_img.classList.remove(this.unloadedClass);
      this.el_img.classList.add('lazzy-loaded');
      this.removeLoader();
      this.destroy();
    }
  }

  removeLoader() {
    if (this.el_loader) {
      this.el_fragment.removeChild(this.el_loader);
      this.el_loader = null;
    }
  }

  destroy() {
    for (const p in this) {
      if (this.hasOwnProperty(p)) { delete this[p]; }
    }
    this.garbage = true;
  }

  hasLoadSiblingsClass() {
    return this.el_img.classList.contains('lazy-load-siblings');
  }

  preloadImage() {
    if (this.garbage) { return; }
    this.el_loader = new window.Image();
    this.el_fragment.appendChild(this.el_loader);
    this.el_loader.src = this.src;
    this.el_loader.onload = e => this.applySrc();
  }
};

LazzyLoaderPic.prototype.el_fragment = document.createDocumentFragment();


class LazzyLoader {
  constructor() {
    this._update = debounce(e => { this.update(); }, 100, false, true);
    this.observedPics = [];
  }
  init() {
    window.addEventListener('scroll', this._update);
    window.addEventListener('resize', this._update);
  }
  add(el, src, unloadedClass, immediately) {
    src = src || el.getAttribute('data-src') || el.src || '';
    this.observedPics.push(new LazzyLoaderPic(el, src, unloadedClass, immediately));
  }

  update() {
    for (let i = 0; i < this.observedPics.length; i++) {
      this.observedPics[i].update();
    }
  }
}


export default (new LazzyLoader());
